import styled, { css } from 'styled-components';
import { Button, Stack } from '@karma/components';
import { getColor } from '@karma/components/colors';

export const Categories = styled(Stack).attrs({
  fullWidth: 'true',
  justifyContent: 'flex-start',
  spacing: 8,
})`
  flex-flow: wrap;
`;

export const Category = styled(Stack)`
  border-radius: 60px;
  height: 40px;
  padding: 0 12px;
  user-select: none;

  ${({ $selected }) =>
    $selected
      ? css`
          border: 1px solid ${getColor('color1')};
          background: ${getColor('color2')};
          box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.25);
          color: ${getColor('color1')};
        `
      : css`
          border: 1px solid ${getColor('color25')};
          background: ${getColor('color25')};
        `}
`;

export const StyledButton = styled(Button)`
  width: ${({ theme }) => (theme.isMobile ? 140 : 215)}px;
  min-width: unset;
`;
